import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem } from '@mui/material';
const MenuItemPaper = ({ children, ...props }) => {
    return (_jsx(MenuItem, { ...props, disableRipple: true, sx: {
            ':hover': {
                backgroundColor: 'transparent',
                borderWidth: '1px',
                cursor: 'default',
            },
        }, children: children }));
};
export { MenuItemPaper };
